<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
    :fill="color"
  >
    <title>calendar</title>
    <path d="M27.524 4.476h-3.143v-2.095c0-0.579-0.469-1.048-1.048-1.048s-1.048 0.469-1.048 1.048v2.095h-12.571v-2.095c0-0.579-0.469-1.048-1.048-1.048s-1.048 0.469-1.048 1.048v2.095h-3.143c-1.736 0-3.143 1.407-3.143 3.143v19.905c0 1.736 1.407 3.143 3.143 3.143h23.048c1.736 0 3.143-1.407 3.143-3.143v-19.905c0-1.736-1.407-3.143-3.143-3.143zM28.571 27.524c0 0.579-0.469 1.048-1.048 1.048h-23.047c-0.579 0-1.048-0.469-1.048-1.048v-13.619h25.143v13.619zM28.571 11.81h-25.143v-4.191c0-0.579 0.469-1.048 1.048-1.048h3.143v2.095c0 0.579 0.469 1.048 1.048 1.048s1.048-0.469 1.048-1.048v-2.095h12.571v2.095c0 0.579 0.469 1.048 1.048 1.048s1.048-0.469 1.048-1.048v-2.095h3.143c0.579 0 1.048 0.469 1.048 1.048v4.191h-0z" />
    <path d="M9.714 16h-2.095c-0.579 0-1.048 0.469-1.048 1.048s0.469 1.048 1.048 1.048h2.095c0.579 0 1.048-0.469 1.048-1.048s-0.469-1.048-1.048-1.048z" />
    <path d="M17.048 16h-2.095c-0.579 0-1.048 0.469-1.048 1.048s0.469 1.048 1.048 1.048h2.095c0.579 0 1.048-0.469 1.048-1.048s-0.469-1.048-1.048-1.048z" />
    <path d="M24.381 16h-2.095c-0.579 0-1.048 0.469-1.048 1.048s0.469 1.048 1.048 1.048h2.095c0.579 0 1.048-0.469 1.048-1.048s-0.469-1.048-1.048-1.048z" />
    <path d="M9.714 20.19h-2.095c-0.579 0-1.048 0.469-1.048 1.048s0.469 1.048 1.048 1.048h2.095c0.579 0 1.048-0.469 1.048-1.048s-0.469-1.048-1.048-1.048z" />
    <path d="M17.048 20.19h-2.095c-0.579 0-1.048 0.469-1.048 1.048s0.469 1.048 1.048 1.048h2.095c0.579 0 1.048-0.469 1.048-1.048s-0.469-1.048-1.048-1.048z" />
    <path d="M24.381 20.19h-2.095c-0.579 0-1.048 0.469-1.048 1.048s0.469 1.048 1.048 1.048h2.095c0.579 0 1.048-0.469 1.048-1.048s-0.469-1.048-1.048-1.048z" />
    <path d="M9.714 24.381h-2.095c-0.579 0-1.048 0.469-1.048 1.048s0.469 1.048 1.048 1.048h2.095c0.579 0 1.048-0.469 1.048-1.048s-0.469-1.048-1.048-1.048z" />
    <path d="M17.048 24.381h-2.095c-0.579 0-1.048 0.469-1.048 1.048s0.469 1.048 1.048 1.048h2.095c0.579 0 1.048-0.469 1.048-1.048s-0.469-1.048-1.048-1.048z" />
    <path d="M24.381 24.381h-2.095c-0.579 0-1.048 0.469-1.048 1.048s0.469 1.048 1.048 1.048h2.095c0.579 0 1.048-0.469 1.048-1.048s-0.469-1.048-1.048-1.048z" />
  </svg>
</template>

<script>
export default {
  name: 'SvgCalendar',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
